export const ApiUrl = 'https://2026nmkdakbapi.kjcxchina.com'
export const startTime = '2026/06/15 00:00:00'             // 活动开始时间
export const endTime = '2026/08/31 23:59:59'               // 活动结束时间
export const showCertificateTime = '2026/07/16 00:00:00'   // 证书显示时间
export const lotteryStartTime = '2026/08/21 00:00:00'      // 抽奖开始时间
export const lotteryEndTime = '2026/08/27 23:59:59'        // 抽奖结束时间（27日24:00）

// 安全获取 UA，避免部分环境 navigator 不存在报错
const getUA = () => {
  if (typeof navigator === 'undefined') return ''
  return navigator.userAgent || ''
}

// 是否为鸿蒙系统（含 NEXT 纯血版）
export const IsHarmonyOS = (ua = getUA()) => {
  const userAgent = String(ua || '').toLowerCase()

  return /openharmony|harmonyos|arkweb|ohos|miniprogramenv\/ohos/.test(userAgent)
}

// 判断是否为微信浏览器
export const IsWeiXin = () => {
  const ua = getUA().toLowerCase()
  return /micromessenger|wechat\/|weixin\//.test(ua)
}

// 是否为鸿蒙微信
export const IsHarmonyWeChat = (ua = getUA()) => {
  const userAgent = String(ua || '').toLowerCase()

  return (
    IsHarmonyOS(userAgent) &&
    /micromessenger|wechat\/|weixin\/|miniprogramenv\/ohos|mmwebsdk|xweb/.test(userAgent)
  )
}

// 判断是否为移动端环境
const isMobileEnv = () => {
  const uaRaw = getUA()
  const ua = uaRaw.toLowerCase()

  // 1. 微信内打开一律走移动端（含鸿蒙微信、扫码等场景）
  if (/micromessenger|wechat\/|weixin\/|miniprogramenv|mmwebid|mmwebsdk|xweb\//.test(ua)) {
    return true
  }

  // 2. 鸿蒙系统：OpenHarmony / HarmonyOS / ArkWeb / ohos
  if (/openharmony|harmonyos|arkweb|ohos/.test(ua)) {
    return true
  }

  // 3. 鸿蒙典型 UA：Phone / Tablet / PC（NEXT 2in1 也可能是 PC 标识但仍需移动端页）
  if (/\((phone|tablet|pc);/.test(ua) && /openharmony|harmonyos|arkweb/.test(ua)) {
    return true
  }

  // 4. 新版 Chromium 移动端标识
  if (
    typeof navigator !== 'undefined' &&
    navigator.userAgentData &&
    navigator.userAgentData.mobile === true
  ) {
    return true
  }

  // 5. 鸿蒙典型 UA：Phone / Tablet
  if (/\((phone|tablet);/.test(ua)) {
    return true
  }

  // 6. 微信 XWEB / 系统 WebView 内核
  if (/;\s*wv\)|xweb\/|mmwebsdk/.test(ua)) {
    return true
  }

  // 7. 触摸屏 + 小屏兜底（maxTouchPoints 为 1 的单点触控也要识别）
  if (typeof window !== 'undefined') {
    const hasTouch =
      (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0) ||
      'ontouchstart' in window

    const smallScreen =
      window.innerWidth <= 1024 ||
      (typeof screen !== 'undefined' && screen.width <= 1024)

    if (hasTouch && smallScreen) {
      return true
    }
  }

  // 8. 常规移动端 UA
  const mobileAgents = [
    'android',
    'iphone',
    'symbianos',
    'windows phone',
    'ipad',
    'ipod',
    'xiaomi',
    'redmi',
    'poco',
    'oppo',
    'vivo',
    'iqoo',
    'oneplus',
    'realme',
    'samsung',
    'meizu',
    'zte',
    'nubia',
    'huawei',
    'honor',
    'mobile'
  ]

  return mobileAgents.some(agent => ua.includes(agent))
}

// 判断客户端
export const IsPC = () => {
  return !isMobileEnv()
}

// 验证手机号
export const IsRegular = (data) => {
  return /^1[3456789]\d{9}$/.test(data)
}

// 验证身份证号
export const VerificationCard = (data) => {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(data)
}

// 判断是否为 iOS
export const IsIOS = () => {
  const ua = getUA().toLowerCase()

  const isIos = /\(i[^;]+;( u;)? cpu.+mac os x/.test(ua)

  // iPadOS 13+ 可能会伪装成 Mac
  const isIPadOS =
    typeof navigator !== 'undefined' &&
    navigator.platform === 'MacIntel' &&
    navigator.maxTouchPoints > 1

  return isIos || isIPadOS
}

// 手机号 / 邮箱脱敏
export const Desensitization = (data) => {
  if (!data) return ''

  const value = String(data)

  if (value.includes('@')) {
    const email = value.split('@')

    if (email[0].length > 4) {
      return email[0].substring(0, email[0].length - 3) + '*****' + email[1]
    } else {
      return '*****' + email[1]
    }
  } else {
    return value.slice(0, 3) + '****' + value.slice(value.length - 4)
  }
}